import { type LawFields, LawFieldsService, type TUser } from '@/types/generated'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useLawFieldStore = defineStore('lawFieldStore', () => {
  const lawFields = ref<LawFields | null>(null)

  const fetchLawFields = async () => {
    if (!lawFields.value) {
      lawFields.value = await LawFieldsService.lawFieldsRetrieve()
    }
  }

  const getLawFieldOptions = (user: TUser) => {
    const lawFields = user?.org.law_fields || []
    return (lawFields as string[]).map((lawField) => ({
      value: lawField,
      title: lawField
    }))
  }

  const getLawTopicOptions = (lawField: string) => {
    if (!lawFields.value) return []
    if (!lawField) return []
    const mappedOptions = (
      lawFields.value?.data[lawField]?.map((topic) => ({
        value: topic,
        title: topic
      })) || []
    ).sort((a, b) => a.value.localeCompare(b.value))

    return mappedOptions
  }

  return {
    lawFields,
    fetchLawFields,
    getLawTopicOptions,
    getLawFieldOptions
  }
})
